module.exports = __webpack_public_path__ + "catalog/items/firesafety/direction-diagonal-bottom-right/direction-diagonal-bottom-right.svg";